/**
 * Helper for using bootstrap 5 carousel controls without id
 * Control node must be carousel child element
 */
let _config = {
    selectorDirection: '[data-bs-slide]',
    selectorIndicator: '[data-bs-slide-to]',
    directionAttribute: 'data-bs-slide',
    indicatorAttribute: 'data-bs-slide-to',
    skipControlAttribute: 'data-bs-target'
}

const bootstrapCarouselControl = (Carousel, config = {}) => {
    _config = {..._config, ...config}
    const controlsDirection = document.querySelectorAll(_config.selectorDirection)
    const controlsIndicator = document.querySelectorAll(_config.selectorIndicator)

    const getCarousel = control => {
        const carousel = control.closest('.carousel')
        return carousel ? Carousel.getOrCreateInstance(carousel) : null
    }

    const handlerDirection = control => {
        const carousel = getCarousel(control)
        if (carousel) control.getAttribute(_config.directionAttribute) === 'prev' ? carousel.prev() : carousel.next()
    }
    
    const handlerIndicator = control => {
        const carousel = getCarousel(control)
        if (carousel) carousel.to(control.getAttribute(_config.indicatorAttribute))
    }

    controlsDirection.forEach(control => {
        if (control.hasAttribute(_config.skipControlAttribute)) return
        control.addEventListener('click', event => {
            event.preventDefault()
            handlerDirection(control)
        })
    })

    controlsIndicator.forEach(control => {
        if (control.hasAttribute(_config.skipControlAttribute)) return
        control.addEventListener('click', event => {
            event.preventDefault()
            handlerIndicator(control)
        })
    })
}

export default bootstrapCarouselControl